import { type Material, type MaterialPluginBase, MultiMaterial, type Nullable, PBRMaterial } from '@babylonjs/core';

export const addMaterialPlugin = (material: Nullable<Material>, materialName: string, config: {}) => {
  let customMaterials: MaterialPluginBase[] = [];
  if (material) {
    if (material instanceof MultiMaterial) {
      customMaterials = material.subMaterials.flatMap((subMaterial) => {
        if (subMaterial) {
          const pluginMaterial = setMaterialConfig(subMaterial, materialName, config);
          if (pluginMaterial) return pluginMaterial;
        }

        return [];
      });
    } else {
      const pluginMaterial = setMaterialConfig(material, materialName, config);
      if (pluginMaterial) customMaterials = [pluginMaterial];
    }
  }

  return customMaterials;
};

export const setMaterialConfig = (material: Material, materialName: string, config: {}) => {
  // PBRMaterial 외 plugin 확장 방지 plugin 작성 시 여러 Material 호환하면서 작업하기 어려워 특수한 경우가 생기지 않는다면 PBRMaterial만 확장되도록 함
  if (!(material instanceof PBRMaterial) || !material.pluginManager) return;

  let plugin: Nullable<MaterialPluginBase> = null;
  plugin = material.pluginManager.getPlugin(materialName);

  if (plugin) {
    // @ts-ignore
    plugin.config = config;
    // @ts-ignore
    plugin.isEnabled = true;

    return plugin;
  }
};
